import { v1 as uuid } from 'uuid';

import ROUTES from '../../components/Routes/constants';
import { TradeStateNew } from '../types/trade';

export const SEARCH_IN = {
  SELL: 'sell',
  BUY: 'buy'
};

export const SEARCH_KEY = {
  TRIGGER: 83,
  ENTER: 13,
  ESC: 27
};

export const MAX_RECENT_SEARCH = 5;

export const RECENT_SEARCH_KEY = 'recentSearch';

export const SEARCH_STATES_ITEMS = [
  {
    id: uuid(),
    testId: 'search-all',
    labelKey: 'search.all.trades',
    label: 'All results',
    labelFr: 'Tous les résultats',
    context: TradeStateNew.ALL
  },
  {
    id: uuid(),
    testId: 'search-parked',
    labelKey: 'search.parked.trades',
    label: 'Parked',
    labelFr: 'Stationné',
    context: TradeStateNew.PARKED
  },
  {
    id: uuid(),
    testId: 'search-upcoming',
    linkTo: ROUTES.BUYING_UPCOMING,
    labelKey: 'search.upcoming.trades',
    label: 'Upcoming',
    labelFr: 'À Venir',
    context: TradeStateNew.UPCOMING
  },
  {
    id: uuid(),
    testId: 'search-active',
    linkTo: ROUTES.BUYING_ACTIVE,
    labelKey: 'search.active.auction',
    label: 'Active auction',
    labelFr: 'Actif',
    context: TradeStateNew.ACTIVE
  },
  {
    id: uuid(),
    testId: 'search-pending',
    linkTo: ROUTES.BUYING_PENDING,
    labelKey: 'search.pending',
    label: 'Pending',
    labelFr: 'En Attente',
    context: TradeStateNew.PENDING
  },
  {
    id: uuid(),
    testId: 'search-closing',
    linkTo: ROUTES.BUYING_CLOSING,
    labelKey: 'search.closing',
    label: 'Closing',
    labelFr: 'Fermeture',
    context: TradeStateNew.CLOSING
  },
  {
    id: uuid(),
    testId: 'search-won',
    linkTo: ROUTES.BUYING_WON,
    labelKey: 'search.won',
    label: 'Won',
    labelFr: 'Gagné',
    labelOmp: 'Sold',
    labelOmpFr: 'Vendu',
    context: TradeStateNew.WON
  },
  {
    id: uuid(),
    testId: 'search-arrived',
    linkTo: ROUTES.BUYING_ARRIVED,
    labelKey: 'search.arrived',
    label: 'Arrived',
    labelFr: 'Arrivé',
    labelOmp: 'Landed',
    labelOmpFr: 'Reçu',
    context: TradeStateNew.ARRIVED
  },
  {
    id: uuid(),
    testId: 'search-delivered',
    linkTo: ROUTES.BUYING_DELIVERED,
    labelKey: 'search.delivered',
    label: 'Delivered',
    labelFr: 'Livré',
    labelOmp: 'Picked up',
    labelOmpFr: 'Récupéré',
    context: TradeStateNew.DELIVERED
  },
  {
    id: uuid(),
    testId: 'search-lost',
    labelKey: 'search.selling.lost',
    label: 'Lost',
    labelFr: 'Perdidas',
    labelOmp: 'Not sold',
    labelOmpFr: 'Non vendu',
    context: TradeStateNew.LOST
  }
];
